<template>
	<div id="editor">

		<span class="hidden-md-and-up display-1">O resultam coder foi projetado para telas maiores.</span>

		<!-- Div para esconder o conteudo caso a tela seja pequena demais -->
		<div class="hidden-sm-and-down">

			<v-toolbar dark flat class="toolbar">
				<router-link to="/" class="logo">
					<img src="../assets/coder_logo.svg">
				</router-link>

				<v-spacer/>

				<!-- Botão de executar o código digitado -> Aparece apenas se o switch for desligado -->
				<v-btn v-if="!watchCode" @click="codePreview = code" color="accent">
					Executar
				</v-btn>

				<!-- Switch de alternar visualização -->
				<v-switch label="Assistir código" v-model="watchCode" class="switch-toolbar px-3" color="accent"></v-switch>

				<v-divider vertical/>

				<!-- Botão de Fullscreen -->
				<v-tooltip bottom>
					<v-toolbar-side-icon  @click="dialog = true, snackbar = true" slot="activator">
						<v-icon>fullscreen</v-icon>
					</v-toolbar-side-icon>
					<span>Tela Cheia</span>
				</v-tooltip>

				<v-spacer/>

				<!-- Botão de salvar HTML digitado, com tooltip abaixo -->
				<v-tooltip bottom>
					<v-btn icon @click="exportCode()" id="csvExport" slot="activator">
						<v-icon>cloud_download</v-icon>
					</v-btn>
					<span>Baixar HTML</span>
				</v-tooltip>

				<!-- Botão para exportar o link do código, com tooltip abaixo -->
				<v-tooltip bottom>
					<v-btn icon @click="shareCode()" slot="activator">
						<v-icon>share</v-icon>
					</v-btn>
					<span>Criar link externo</span>
				</v-tooltip>

				<!-- Botão para abrir o perfil -->
				<v-tooltip bottom>
					<v-btn flat @click="openMenu()" dark icon slot="activator" id="profileBtn"><v-icon>person</v-icon></v-btn>
					<span>Conta</span>
				</v-tooltip>

				<!-- Menu do perfil -->
				<v-menu absolute v-model="menu" :position-x="menuX" :position-y="menuY" :close-on-content-click="false" :nudge-width="300" transition="slide-y-transition" class="popover">
					<v-card>
						<!-- Nome e e-mail -->
						<v-list>
							<v-list-tile>
								<v-list-tile-content v-if="user">
									<v-list-tile-title>{{ user.displayName }}</v-list-tile-title>
									<v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-content v-else>
									<v-list-tile-title>Desconectado</v-list-tile-title>
									<v-list-tile-sub-title>Entre para mais opções</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-btn icon flat @click="menu = false">
										<v-icon>close</v-icon>
									</v-btn>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
						<v-divider/>
						<!-- Alerta de confirmação de e-mail -->
						<v-alert v-model="emailConfirmation" :value="true" type="success" dismissible>E-mail confirmado com sucesso!</v-alert> 
						<!-- Formulário de login -->
						<div v-if="!user && !registerForm" class="pa-3">
							<v-form name="login-form" ref="form" lazy-validation @submit.prevent="login()">
								<v-text-field label="E-mail" v-model="form.email" required ></v-text-field>
								<v-text-field type="password" label="Senha" v-model="form.password" required></v-text-field>
								<v-btn block type="submit" color="accent" :loading="loadingBtn" :disabled="loadingBtn">Entrar</v-btn>
								<div class="pt-2">
									<v-btn block small flat :ripple="false" color="primary" @click="registerForm = true">Ainda não tem conta? Cadastre-se!</v-btn>
								</div>
								<v-alert v-if="firebaseError == true" :value="true" type="error">{{this.error}}</v-alert>
							</v-form>
						</div>

						<!-- Formulário de Cadastro -->
						<div v-else-if="!user && registerForm" class="pa-3">
							<v-form name="register-form" ref="form" lazy-validation @submit.prevent="register()" v-model="valid">
								<v-text-field label="Nome" v-model="form.name" :rules="nameRules" required ></v-text-field>
								<v-text-field label="E-mail" v-model="form.email" :rules="emailRules" required ></v-text-field>
								<v-text-field type="password" label="Senha" v-model="form.password" :rules="passwordRules" required></v-text-field>
								<v-btn block type="submit" color="accent" :loading="loadingBtn" :disabled="loadingBtn || !form.name || !form.email || !form.password || !valid">Registrar</v-btn>
								<div class="pt-2">
									<v-btn block small flat :ripple="false" color="primary" @click="registerForm = false">Já possui uma conta? Entre.</v-btn>
								</div>
								<v-alert v-if="firebaseError == true" :value="true" type="error">{{this.error}}</v-alert>
							</v-form>
						</div>

						<!-- Formulário de editar nome -->
						<div v-else-if="user && nameForm" class="pa-3">
							<v-form name="name-form" ref="form" lazy-validation @submit.prevent="updateName()">
								<v-text-field :placeholder="user.displayName" v-model="form.name" required></v-text-field>
								<v-btn type="submit" color="accent">Atualizar nome</v-btn>
								<v-btn flat :ripple="false" color="primary" @click="nameForm = false">Cancelar</v-btn>
							</v-form>
						</div>

						<!-- Formulário de editar senha -->
						<div v-else-if="user && passwordForm" class="pa-3">
							<v-form name="password-form" ref="form" lazy-validation @submit.prevent="updatePassword()">
								<v-text-field type="password" label="Nova senha" v-model="form.password" required ></v-text-field>
								<v-btn type="submit" color="accent">Atualizar senha</v-btn>
								<v-btn flat :ripple="false" color="primary" @click="passwordForm = false">Cancelar</v-btn>
							</v-form>
						</div>

						<!-- Logado -->
						<div v-else-if="user.emailVerified == false" class="pa-3">
							<v-alert type="warning" :value="true" outline>Verifique seu e-mail.</v-alert>
							<v-btn block @click="resendEmailVerify()" :loading="loadingBtn2" :disabled="loadingBtn2">Reenviar e-mail de verificação</v-btn>
							<v-btn block color="accent" @click="logout()" :loading="loadingBtn" :disabled="loadingBtn">Sair</v-btn>
						</div>
						<div v-else class="pa-3">
							<v-btn flat block :ripple="false" color="primary" @click="nameForm = true"><v-icon left>edit</v-icon>Alterar nome</v-btn>
							<v-btn flat block :ripple="false" color="primary" @click="passwordForm = true"><v-icon left>lock</v-icon>Alterar senha</v-btn>
							<v-btn block color="accent" @click="logout()" :loading="loadingBtn" :disabled="loadingBtn">Sair</v-btn>
						</div>

					</v-card>
				</v-menu>

			</v-toolbar>

			<!-- Conteúdo do site -->
			<v-layout row wrap class="px-4">
				<!-- Codemirror -->
				<v-flex xs12 sm12 lg6>
					<div class="code-wrapper">
						<!-- Botão de trocar o tema do codemirror -->
						<v-btn icon @click="changeTheme()" class="change-theme white--text" id="btnTheme">
							<v-icon>brightness_6</v-icon>
						</v-btn>
						<codemirror id="codemirror" ref="myCm" :value="code" :options="cmOptions" @ready="onCmReady" @focus="onCmFocus" @input="onCmCodeChange" autosize></codemirror>
					</div>
				</v-flex>
				<!-- Iframe -->
				<v-flex xs12 sm12 lg6>
					<iframe :srcdoc="codePreview" class="code code-right"></iframe>
				</v-flex>
			</v-layout>

			<!-- Dialog para a simulação de um fullscreen -->
			<v-dialog v-model="dialog" class="code-dialog" @keydown.esc="dialog = false, snackbar = false">
				<iframe :srcdoc="codePreview" class="code-fullscreen"></iframe>
			</v-dialog>

			<!-- Dialog para exibir o código a ser exportado -->
			<v-dialog v-model="dialogCode" width="500" @keydown.esc="dialogCode = false, snackbar = false">
				<v-card dark>
					<v-card-title primary-title>
						<div>
							<h3 v-if="!user" class="headline mb-0">Faça login para compartilhar seu código!</h3>
							<h3 v-else-if="user.emailVerified == false">Você precisa confirmar seu e-mail para continuar!</h3>
							<h3 v-else class="headline mb-0">Link do seu código:</h3>
						</div>
					</v-card-title>
					<v-card-text>
						<div v-if="!user">
							<v-btn block @click="requireLogin()" light color="accent" slot="activator" id="profileBtn">Entrar</v-btn>
						</div>
						<div v-else-if="user.emailVerified == false">
							<v-btn block @click="requireLogin()" light color="accent" slot="activator" id="profileBtn">Perfil</v-btn>
						</div>
						<div v-else style="position:relative;">
							<v-text-field readonly light label="Link" solo :value="codeExport" id="input-link"></v-text-field>
							<v-btn light class="copy-button" @click="copyLink()"><v-icon>description</v-icon></v-btn>
						</div>
					</v-card-text>
				</v-card>
			</v-dialog>

		</div>
	</div>
</template>

<script>
// Codemirror programming language
import 'codemirror/mode/htmlmixed/htmlmixed.js'

// Codemirror themes
import 'codemirror/theme/base16-dark.css'
import 'codemirror/theme/eclipse.css'

import { auth, db, googleProvider } from '../firebaseInit'

const codesRef = db.ref('codes')

var provider = googleProvider
auth.languageCode = 'pt'

export default {
	name: 'Editor',
	beforeCreate: function() {
		auth.onAuthStateChanged((user) => {
			if (user) {
				// Set logged user data
				this.user = user
			}
		})
	},
	mounted() {
		// Verificar a URL para confirmação de e-mail (link do e-mail)
		console.log(this.$route)
		if(this.$route.query.emailConfirmed == 'true') {
			this.emailConfirmation = true
			this.openMenu()
			this.menuX = window.innerWidth / 2 - 150
		}
		// Substituir aspas convertidas de volta para aspas
		if(this.$route.query.uid && this.$route.query.codeid){
			// this.code = this.$route.query.code.replace(/ç~/g, "'").replace(/~z/g, '"').replace(/~q/g, ' ')
			var loadCode = codesRef.child(this.$route.query.uid + '/' + this.$route.query.codeid)
			loadCode.once('value').then(function(codeLoaded){
				this.code = codeLoaded.val().content.replace(/ç~/g, "'").replace(/~z/g, '"').replace(/~q/g, ' ')
			}.bind(this))
		} else {
			// Texto padrão de exibição (Caso o URL estaja vazio)
			this.code = '<!DOCTYPE html>\n<html>\n<head>\n\t<link href="https://fonts.googleapis.com/css?family=Lato" rel="stylesheet">\n\t<meta charset="utf-8" />\n\t<meta http-equiv="X-UA-Compatible" content="IE=edge">\n\t<title>Page Title</title>\n\t<meta name="viewport" content="width=device-width, initial-scale=1">\n</head>\n\t<body>\n\t\t<h1>Editor Resultam</h1>\n\t\t<p>Aqui você pode escrever <strong>o seu</strong> html!</p>\n\t\t<a target="blank" href="https://resultam.com">Resultam.com</a>\n\t</body>\n</html>\n<style>\n\thtml {\n\t\tfont-family: "Lato", sans-serif;\n\t}\n</style>'
		}
		this.codePreview = this.code

  },
	data: () => ({
		// Menu
		menu: false,
		menuX: window.innerWidth,
		menuY: 0,
		// Habilitar Cadastro
		registerForm: false,
		// Habilitar editors
		nameForm: false,
		passwordForm: false,
		// Logged user data
		user: null,
		loginWithEmail: false,
		form: {
			name: null,
			email: null,
			password: null,
   	 	error: null,
		},
		// User code variables
		code: null,
		codePreview: null,
		// Dialog variables
		dialog: false,
		dialogCode: false,
		// User controls variables
		watchCode: true,
		watchCodeText: "Assistindo Código",
		codeExport: '',
		// Switch toggle
		toggle_exclusive: 0,
		// Loading button
		loadingBtn: false,
		loadingBtn2: false,
		// Alert de confirmação de e-mail
		emailConfirmation: false,
		// Validação de forms
		valid: true,
		emailRules: [
      v => !!v || 'Digite um email.',
      v => /.+@.+/.test(v) || 'E-mail inválido!'
    ],
		nameRules: [
      v => !!v || 'Digite um nome.',
      v => (v && v.length >= 3) || 'O nome deve ter pelo menos 3 dígitos!'
    ],
		passwordRules: [
      v => !!v || 'Digite uma senha.',
      v => (v && v.length >= 6) || 'No mínimo 6 caracteres!'
    ],
		// Firebase Error alert
		firebaseError: false,
		error: null,
		// Codemirror options
		cmOptions: {
			tabSize: 2,
			mode: 'htmlmixed',
			theme: 'base16-dark',
			lineNumbers: true,
			line: true,
			lineWrapping: true,
			scrollbarStyle: null,
		},
		// Codemirror themes
		themes: [
			{
				name: 'Tema claro',
				color: 'eclipse'
			},
			{
				name: 'Tema escuro',
				color: 'base16-dark'
			}
		]
	}),
  methods: {
    onCmReady(cm) {
      // console.log('the editor is readied!', cm)
    },
    onCmFocus(cm) {
      // console.log('the editor is focus!', cm)
    },
    onCmCodeChange(newCode) {
      // console.log('this is new code', newCode)
      this.code = newCode
    },
		// Download do código digitado
		exportCode() {
				var result = 'data:text/html,'
        result += this.code
				const dataExport = encodeURI(result);
        const link = document.createElement("a");
        link.setAttribute("href", dataExport);
        link.setAttribute("download", "resultamcoder-codigo.html");
        link.click();
		},
		// Definir o conteudo do iframe como o codigo digitado
		iframeContent() {
				this.codePreview = this.code
		},
		changeTheme() {
			if(this.cmOptions.theme == 'eclipse'){
				this.cmOptions.theme = 'base16-dark'
				document.getElementById('btnTheme').classList.add('white--text')
				document.getElementById('btnTheme').classList.remove('black--text')
			}else{
				this.cmOptions.theme = 'eclipse'
				document.getElementById('btnTheme').classList.add('black--text')
				document.getElementById('btnTheme').classList.remove('white--text')
			}
		},
		// Converter aspas, espaços e tabs para fazer a url de exportação
		shareCode() {
			this.dialogCode = true
			this.snackbar = true
			if(this.user){
				// this.codeExport = window.location.protocol + '//' + window.location.host +'/?code=' + this.code.replace(/\n/g,'%0A').replace(/\t/g,'%09').replace(/'/g, 'ç~').replace(/"/g, '~z').replace(/\s/g, '~q');
				var userCodesRef = codesRef.child(this.user.uid)
				var newCode = userCodesRef.push()
				newCode.set({
					// content: this.code.replace(/\n/g,'%0A').replace(/\t/g,'%09').replace(/'/g, 'ç~').replace(/"/g, '~z').replace(/\s/g, '~q')
					content: this.code
				}).then( code => {
					var link = window.location.protocol + '//' + window.location.host +'/?uid=' + this.user.uid + '&codeid=' + newCode.key
					this.codeExport = link
					// this.lastCode = newCode.key
				}, function(err){
					console.log(err)
				}.bind(this))
			}
		},
		copyLink() {
			var copyText = document.getElementById('input-link');
			copyText.select();
			document.execCommand('copy');
		},
		login() {
			this.loadingBtn = true
      auth.signInWithEmailAndPassword(this.form.email, this.form.password).then(
        data => {
					this.clearForms()
					this.loadingBtn = false
					this.firebaseError = false
        },
        function(err) {
					this.loadingBtn = false
					this.firebaseError = true
          console.log(err)
          switch (err.code) {
            case 'auth/invalid-email':
              this.error = 'Email não cadastrado.'
              break;
            case 'auth/user-disabled':
              this.error = 'Usuário desabilitado.'
              break;
            case 'auth/user-not-found':
              this.error = 'Usuário inexistente.'
              break;
            case 'auth/wrong-password':
              this.error = 'Senha Incorreta.'
              this.password = null
              break;
            default:
              this.error = 'Não foi possível se conectar, tente novamente mais tarde.'
          }
        }.bind(this)
      )
    },
		register(){
			this.loadingBtn = true
			auth.createUserWithEmailAndPassword(this.form.email, this.form.password)
			.then(
				data => {
					data.user.updateProfile({
						displayName: this.form.name
					}).catch(function(err) {
						console.log(err)
					})
					data.user.sendEmailVerification().then(function() {
						// Email sent.
					}).catch(function(err) {
						console.log(err)
					})
					this.clearForms()
					this.loadingBtn = false
					this.firebaseError = false
				},
				function(err) {
					this.loadingBtn = false
					this.firebaseError = true
					console.log(err)
					switch(err.code){
						case 'auth/email-already-in-use':
							this.error = 'Email já cadastrado.'
							break;
						case 'auth/invalid-email':
							this.error = 'Email inválido.'
							break;
						case 'auth/operation-not-allowed':
							this.error = 'Operação não permitida.'
							break;
						case 'auth/weak-password':
							this.error = 'Senha muito fraca.'
							break;
						default:
							this.error = 'Não foi possível finalizar o cadastro, tente novamente mais tarde.'
					}
				}.bind(this)
			)
		},
		logout() {
			this.firebaseError = false
			this.loadingBtn = true
			auth.signOut().then(function() {
				this.user = null
				this.clearForms()
				this.loadingBtn = false
			}.bind(this)).catch(function(err) {
				this.loadingBtn = false
				console.log(err)
			})
		},
		updateName() {
			this.user.updateProfile({
				displayName: this.form.name
			}).catch(function(err) {
				console.log(err)
			})
			this.clearForms()
		},
		updatePassword() {
			var user = this.user
			var newPassword = this.form.password
			var credential
			user.reauthenticateAndRetrieveDataWithCredential(credential).then(function() {
				user.updatePassword(newPassword).then(function() {
					console.log('Senha atualizada')
				}).catch(function(error) {
					console.log('Fudeu de vez!')
				})
			}).catch(function(error) {
				console.log('Fudeu de vez²!')
			})
		},
		clearForms() {
			this.form.name = null
			this.form.email = null
			this.form.password = null
			this.menu = false
		},
		requireLogin() {
			this.menu = true,
			this.dialog = false,
			this.firebaseError = false,
			this.dialogCode = false
		},
		resendEmailVerify() {
			this.loadingBtn2 = true
			// var user = auth.currentUser
			this.user.sendEmailVerification().then(function() {
				// Email sent.
				setTimeout(() => (this.loadingBtn2 = false), 10000)
			}.bind(this)).catch(function(err) {
				console.log(err)
			})
		},
		openMenu() {
			this.menu = true,
			this.menuX = window.innerWidth
		}
  },
  computed: {
    codemirror() {
      return this.$refs.myCm.codemirror
    }
  },
	watch: {
		code: {
			deep: true,
			handler(val) {
				if(this.watchCode){
					this.codePreview = val
				}
			}
		},
		watchCode: {
			deep: true,
			handler(val) {
				this.codePreview = this.code
				if(this.watchCode){
					this.watchCodeText = 'Assistindo código'
				}else{
					this.watchCodeText = 'Assistir código'
				}
			}
		},
	}
}
</script>

<style lang="scss" scoped>
	@import url(https://fonts.googleapis.com/css?family=Chakra+Petch);
  a {
    color:inherit;
  }
	iframe.code-right {
		width: 100%;
		height: 100%;
		min-height: 145px;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 0 0 0 10px;
		margin: 0;
		border: 0;
		font-size: 100%;
		font: initial;
		vertical-align: baseline;
	}
	.code-fullscreen {
		background-color: white;
		min-height: calc(88vh + 4px);
		padding: 0;
		margin: 0;
		border: 0;
		font-size: 100%;
		font: initial;
		vertical-align: baseline;
		width: 100%;
		margin-bottom: -4px;
	}
	.toolbar {
		margin-bottom: 20px;
		.switch-toolbar {
			flex: none;
			padding-top: 22px;
		}
		.logo {
			width: 195px;
		}
	}
	.code-wrapper {
		position: relative;
		.change-theme {
			position: absolute !important;
			z-index: 10;
			right: 0;
		}
	}
	.copy-button {
		top:0px;
		right:0px;
		height:48px;
		margin:0px;
		position: absolute;
		color: rgba(0, 0, 0, 0.54);
		&:hover {
			position: absolute !important;
		}
	}
	.popover {
		z-index: 9999;
	}
</style>